import { ReactNode } from "react"
import expect from "../util/expect"
import { useAppSelector } from "../redux/store/hooks"
import { selectProfessionalUser } from "../redux/ProfessionalAuthentication"
import BackIcon from "../icon/BackIcon"

interface DashboardWrapperProps {
    children: ReactNode
    title?: ReactNode
    onClick?: () => void
    maxWidth?: number
}

function DashboardWrapper(props: DashboardWrapperProps) {
    const professional = expect(useAppSelector(selectProfessionalUser))

    return (
        <div className={"w-full flex justify-center"}>
            <div
                style={{
                    maxWidth: props.maxWidth
                }}>
                <div className={"m-4 flex flex-col space-y-5"}>
                    <div className={"flex items-end"}>
                        <div onClick={() => {
                            if (props.onClick) props.onClick()
                        }} className={"flex items-center space-x-2 " + (props.onClick
                            ? "cursor-pointer hover:text-blue-600"
                            : "")}>
                            {props.onClick !== undefined && (
                                <BackIcon />
                            )}
                            <div
                                className={
                                    "text-4xl font-bold"
                                }>
                                {props.title
                                    ? props.title
                                    : professional.officeName}
                            </div>
                        </div>
                        <div className={"ml-auto"}>
                            Heute ist der {new Date().toLocaleDateString("de")}
                        </div>
                    </div>
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export default DashboardWrapper
